import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import PredefinedDateRanges from "../../../core/common/datePicker";
import Table from "../../../core/common/dataTable/index";
import api from "../../../services/api";
import CommonSelect from "../../../core/common/commonSelect";
import { showBasicAlert } from "../../../core/common/useAlert";
import Loader from "../../../core/common/loader";
import DeleteModal from "../../../core/modals/deleteModal";
import "./add-pipeline.css";

interface FormField {
  id: number;
  name: string;
}
interface FormFieldColor {
  id: number;
  color: string;
}
interface StageConfig {
  id: number;
  require_reminder: boolean;
  stage_type: "normal" | "won" | "lost";
}

const Pipeline = () => {
  const signature = localStorage.getItem("signature");
  const [isLoading, setIsLoading] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [pipelineName, setPipelineName] = useState("");
  const [pipelineType, setpipelineType] = useState("");

  const [stages, setStages] = useState<FormField[]>([]);
  const [stagesColor, setStagesColor] = useState<FormFieldColor[]>([]);
  const [stagesConfig, setStagesConfig] = useState<StageConfig[]>([]);
  const [getAllCompanyList, setgetAllCompanyList] = useState<any[]>([]);

  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState(data);

  useEffect(() => {
    // This will run when the component mounts
    const fetchDashboardData = async () => {
      try {
        await updateUI();
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };

    fetchDashboardData();
  }, []);

  var initialformDataAddNewPipeline = {
    signature: signature,
    companyName: "",
    companyId: "",
    companytype: "",
  };
  const [formDataAddNewPipeline, setformDataAddNewPipeline] = useState(
    initialformDataAddNewPipeline
  );

  const handleInputChange = (e: any) => {
    const { label, value } = e;
    setformDataAddNewPipeline({
      signature: signature,
      companyName: label.split("-")[0].trim(),
      companyId: value,
      companytype: label.split("-")[1].trim(),
    });
  };

  const handleReset = () => {
    setFilteredData(data);
    setStatusFilter("");
    setcompanyFilter("");
    setSortBy("Last 7 Days");
    setSelectedEndDate(null);
    setSelectedStartDate(null);
  };

  const updateUI = async () => {
    setIsLoading(true);
    const [getAllCompanyList, pipelineList] = await Promise.all([
      api.post("userService/getAllCompanyList", { signature }),
      api.post("leadService/getAllPipelines", { signature }),
    ]);
    setgetAllCompanyList(getAllCompanyList.data.data.data);
    setData(pipelineList.data.data.data);
    setFilteredData(pipelineList.data.data.data);

    setformDataAddNewPipeline({
      signature: signature,
      companyName: getAllCompanyList.data.data.data[0].name.trim(),
      companyId: getAllCompanyList.data.data.data[0].id,
      companytype: getAllCompanyList.data.data.data[0].type.trim(),
    });

    setcompanyFilter(getAllCompanyList?.data?.data?.data[0].name);

    setIsLoading(false);
    return;
  };

  const companyChoose = [
    ...getAllCompanyList.map((company) => ({
      value: company.id,
      label: company.name + " - " + company.type,
    })),
  ];

  const pipeline_type = [
    { value: "lead", label: "Lead" },
    { value: "deal", label: "Deal" },
  ];

  // Add a new stage
  const addStage = async () => {
    const newId = Date.now();
    setStages([...stages, { id: newId, name: "" }]);
    setStagesColor([...stagesColor, { id: newId, color: "" }]);
    setStagesConfig([...stagesConfig, { id: newId, require_reminder: true, stage_type: "normal" }]);
  };
  // Remove a stage
  const removeStage = (id: any) => {
    setStages(stages.filter((stage) => stage.id !== id));
    setStagesColor(stagesColor.filter((stage) => stage.id !== id));
    setStagesConfig(stagesConfig.filter((config) => config.id !== id));
  };
  // Update stage name
  const updateStageName = (id: any, name: any) => {
    setStages(
      stages.map((stage) => (stage.id === id ? { ...stage, name } : stage))
    );
  };
  const updateStageNameColor = (id: any, color: any) => {
    setStagesColor(
      stagesColor.map((stageColor) =>
        stageColor.id === id ? { ...stageColor, color } : stageColor
      )
    );
  };
  // Update stage config
  const updateStageConfig = (id: number, field: string, value: any) => {
    setStagesConfig(
      stagesConfig.map((config) =>
        config.id === id ? { ...config, [field]: value } : config
      )
    );
  };

  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [sortBy, setSortBy] = useState<string>("Last 7 Days");
  const [companyFilter, setcompanyFilter] = useState<string | null>(null);
  const [selectedStartDate, setSelectedStartDate] =
    useState<moment.Moment | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<moment.Moment | null>(
    null
  );

  useEffect(() => {
    if (filteredData) {
      var newFilteredData = data
        .filter((item: any) => {
          if (statusFilter && item.Status !== statusFilter) {
            return false;
          }
          if (companyFilter && item.Company_Name !== companyFilter) {
            return false;
          }
          // Apply date range filter (if dates are selected)
          if (selectedStartDate && selectedEndDate) {
            const createdDate = new Date(item.CreatedDate);

            // Convert moment objects to Date objects if needed
            const startDate =
              selectedStartDate instanceof Date
                ? selectedStartDate
                : selectedStartDate.toDate();
            const endDate =
              selectedEndDate instanceof Date
                ? selectedEndDate
                : selectedEndDate.toDate();

            // Check if the created date is within the selected date range
            if (createdDate < startDate || createdDate > endDate) {
              return false;
            }
          }
          return true;
        })
        .sort((a: any, b: any) => {
          switch (sortBy) {
            case "Recently Added":
              return (
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime()
              );
            case "Ascending":
              return a.Pipeline_Name.localeCompare(b.Pipeline_Name);
            case "Descending":
              return b.Pipeline_Name.localeCompare(a.Pipeline_Name);
            case "Last Month":
              const oneMonthAgo = new Date();
              oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1); // Get the date for one month ago
              const lastMonthCreatedDate =
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime();

              // If the created date is within the last month, continue sorting by CreatedDate
              if (
                new Date(b.CreatedDate) >= oneMonthAgo &&
                new Date(a.CreatedDate) >= oneMonthAgo
              ) {
                return lastMonthCreatedDate;
              } else {
                return 0; // Do not change order if dates are not within the last month
              }
            case "Last 7 Days":
              const sevenDaysAgo = new Date();
              sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7); // Get the date for 7 days ago
              const last7DaysCreatedDate =
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime();

              // If the created date is within the last 7 days, continue sorting by CreatedDate
              if (
                new Date(b.CreatedDate) >= sevenDaysAgo &&
                new Date(a.CreatedDate) >= sevenDaysAgo
              ) {
                return last7DaysCreatedDate;
              } else {
                return 0; // Do not change order if dates are not within the last 7 days
              }

            default: // 'Last 7 Days'
              return (
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime()
              ); // Adjust logic for 'Last 7 Days'
          }
        });
      var dateFilter = [...newFilteredData];
      if (dateFilter.length > 0) {
        setFilteredData(dateFilter); // Update filtered data
      } else {
        if (data.length > 0) {
          setFilteredData([]);
        }
      }
    }
  }, [statusFilter, sortBy, selectedStartDate, selectedEndDate, companyFilter]);

  const handleSubmit = async () => {
    if (!pipelineName || stages.length === 0) {
      alert("Pipeline Name and at least one stage are required.");
      return;
    }

    const payload = {
      signature: formDataAddNewPipeline.signature,
      pipeline_name: pipelineName,
      company_id: formDataAddNewPipeline.companyId,
      company_type: formDataAddNewPipeline.companytype,
      pipeline_stages: stages.map((s) => s.name),
      pipeline_stages_color: stagesColor.map((s) => s.color),
      pipeline_stages_config: stagesConfig.map((config, index) => ({
        stage_name: stages[index]?.name || "",
        stage_color: stagesColor[index]?.color || "#FFFFFF",
        require_reminder: config.require_reminder,
        stage_type: config.stage_type,
      })),
      type: pipelineType,
    };

    try {
      const response = await api.post("leadService/addPipeline", payload);
      setStages([]);
      setStagesColor([]);
      setStagesConfig([]);
      setPipelineName("");
      updateUI();
      showBasicAlert(response.data.message[0].msg);
      document.getElementById("close-model-form")?.click();
    } catch (error: any) {
      showBasicAlert(error.data.message[0].msg);
    }
  };

  const handleDateChange = (start: moment.Moment, end: moment.Moment) => {
    setSelectedStartDate(start);
    setSelectedEndDate(end);
  };

  const [deleteRecord, setDeleteRecord] = useState<{
    key: number;
    name: string;
  } | null>(null);

  const handleDelete = async () => {
    if (deleteRecord) {
      try {
        var id = deleteRecord.key;
        try {
          setIsLoading(true);
          const response = await api.post("leadService/deletePipeline", {
            signature,
            id,
          });
          showBasicAlert(response.data.message[0].msg);
        } catch (error: any) {
          showBasicAlert(error.data.message[0].msg);
        } finally {
          await updateUI();
          setIsLoading(false); // hide loader after response
        }
      } catch (error) {
        console.error("Error deleting item:", error);
        alert("Failed to delete item.");
      }
      setDeleteRecord(null);
    }
  };

  const [selectedPipeline, setSelectedPipeline] = useState<any>(null);
  const [selectedPipelineColor, setSelectedPipelineColor] = useState<any>(null);

  const routes = all_routes;
  const columns = [
    {
      title: "Pipeline Name",
      dataIndex: "Pipeline_Name",
      render: (text: string, record: any) => (
        <h6 className="fs-14 fw-medium">{text}</h6>
      ),
      sorter: (a: any, b: any) =>
        a.Pipeline_Name.length - b.Pipeline_Name.length,
    },
    {
      title: "Company Name",
      dataIndex: "Company_Name",
      render: (text: string, record: any) => (
        <h6 className="fs-14 fw-medium">{text}</h6>
      ),
      sorter: (a: any, b: any) => a.Company_Name.length - b.Company_Name.length,
    },
    {
      title: "Company Type",
      dataIndex: "Company_Type",
      render: (text: string, record: any) => (
        <h6 className="fs-14 fw-medium">{text.toUpperCase()}</h6>
      ),
      sorter: (a: any, b: any) => a.Company_Type.length - b.Company_Type.length,
    },
    {
      title: "Type",
      dataIndex: "Type",
      render: (text: string, record: any) => (
        <h6 className="fs-14 fw-medium">{text.toUpperCase()}</h6>
      ),
      sorter: (a: any, b: any) => a.Type.length - b.Type.length,
    },
    {
      title: "Stages",
      dataIndex: "Stages",
      render: (text: string[], record: any) => (
        <div className="d-flex align-items-center">
          <span className="fs-14 fw-normal">{text.join(" → ")}</span>
        </div>
      ),
      sorter: (a: any, b: any) => a.Stages.length - b.Stages.length,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string) => (
        <>
          <span
            className={`badge d-inline-flex align-items-center badge-xs ${text === "Active" ? "badge-success" : "badge-danger"
              }`}>
            <i className="ti ti-point-filled me-1"></i>
            {text}
          </span>
        </>
      ),
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#edit_pipeline"
            onClick={(e: any) => {
              e.preventDefault();
              setSelectedPipeline(record);
              setSelectedPipelineColor(record);
            }}>
            <i className="ti ti-edit" title="Edit" />
          </Link>
          <Link
            to="#"
            data-bs-toggle="modal"
            data-bs-target="#delete_modal"
            onClick={(e: any) => {
              e.preventDefault();
              setDeleteRecord(record);
            }}>
            <i className="ti ti-trash" title="Delete" />
          </Link>
        </div>
      ),
    },
  ];

  const handleSubmitUpdate = async () => {
    setIsEditLoading(true);
    const payload = {
      signature: signature,
      pipeline_name: selectedPipeline.Pipeline_Name,
      company_id: selectedPipeline.Company_Id,
      company_type: selectedPipeline.Company_Type,
      pipeline_stages: selectedPipeline.Stages || [],
      pipeline_stages_color: selectedPipelineColor?.Color || [],
      pipeline_stages_config: (selectedPipeline.Stages || []).map((stageName: string, index: number) => ({
        stage_name: stageName,
        stage_color: selectedPipelineColor?.Color?.[index] || "#FFFFFF",
        require_reminder: selectedPipeline.Stages_Config?.[index]?.require_reminder !== false,
        stage_type: selectedPipeline.Stages_Config?.[index]?.stage_type || "normal",
      })),
      type: selectedPipeline.Type,
      status: selectedPipeline.Status,
      id: selectedPipeline.key,
    };

    try {
      const response = await api.post("leadService/editPipeline", payload);
      updateUI();
      showBasicAlert(response.data.message[0].msg);
      document.getElementById("cancle-btn-model")?.click();
    } catch (error: any) {
      showBasicAlert(error.data.message[0].msg);
    } finally {
      setIsEditLoading(false);
    }
  };

  if (
    getAllCompanyList.length == 0 &&
    filteredData.length > 0 &&
    data.length > 0
  ) {
    return <Loader />;
  } else {
    return (
      <>
        {isLoading && <Loader />}
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Pipeline</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">CRM</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Pipeline List
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    onClick={(e: any) => e.preventDefault()}
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown">
                    Company {companyFilter}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    {companyChoose?.map((company: any) => (
                      <li key={company.value}>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setcompanyFilter(
                              company.label.split("-")[0].trim()
                            );
                          }}>
                          {company.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="mb-2">
                  <Link
                    to="#"
                    onClick={(e: any) => e.preventDefault()}
                    data-bs-toggle="modal"
                    data-bs-target="#add_pipeline"
                    className="btn btn-primary d-flex align-items-center">
                    <i className="ti ti-circle-plus me-2" />
                    Add Pipeline
                  </Link>
                </div>
                <div className="head-icons ms-2">
                  <CollapseHeader />
                </div>
              </div>
            </div>
            {/* /Breadcrumb */}
            {/* Leads List */}
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <h5>Pipeline List</h5>
                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <div className="me-3">
                    <div className="input-icon-end position-relative">
                      <PredefinedDateRanges onDateChange={handleDateChange} />
                      <span className="input-icon-addon">
                        <i className="ti ti-chevron-down" />
                      </span>
                    </div>
                  </div>

                  <div className="dropdown me-3">
                    <Link
                      to="#"
                      onClick={(e: any) => e.preventDefault()}
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown">
                      Status {statusFilter}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setStatusFilter("Active");
                          }}>
                          Active
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setStatusFilter("Inactive");
                          }}>
                          Inactive
                        </Link>
                      </li>
                    </ul>
                  </div>

                  <div className="dropdown me-3">
                    <Link
                      to="#"
                      onClick={(e: any) => e.preventDefault()}
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown">
                      Sort By: {sortBy}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setSortBy("Recently Added");
                          }}>
                          Recently Added
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setSortBy("Ascending");
                          }}>
                          Ascending
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setSortBy("Descending");
                          }}>
                          Descending
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setSortBy("Last Month");
                          }}>
                          Last Month
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setSortBy("Last 7 Days");
                          }}>
                          Last 7 Days
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={handleReset}>
                      Reset
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body p-0">
                <Table
                  key={JSON.stringify(filteredData)}
                  dataSource={filteredData}
                  columns={columns}
                  Selection={false}
                />
              </div>
            </div>
            {/* /Leads List */}
          </div>
          <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
            <p className="mb-0">2025 © CMS.</p>
            <p>
              Designed & Developed By{" "}
              <Link
                to="#"
                onClick={(e: any) => e.preventDefault()}
                className="text-primary">
                ZYVO
              </Link>
            </p>
          </div>
        </div>
        {/* /Page Wrapper */}
        <div className="modal fade" id="add_pipeline">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content border-0 shadow">
              <div className="modal-header bg-light border-bottom-0">
                <h4 className="modal-title fw-semibold text-primary">
                  Add New Pipeline
                </h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close">
                  <i className="ti ti-x" />
                </button>
              </div>

              <div className="modal-body pt-0">
                {/* Company Selection */}
                <div className="mb-3">
                  <label className="form-label fw-medium">
                    Company <span className="text-danger">*</span>
                  </label>
                  <CommonSelect
                    className="select"
                    options={companyChoose}
                    defaultValue={{
                      value: formDataAddNewPipeline.companyId,
                      label:
                        formDataAddNewPipeline.companyName +
                        " - " +
                        formDataAddNewPipeline.companytype,
                    }}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Pipeline Type */}
                <div className="mb-3">
                  <label className="form-label fw-medium">
                    Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="gender"
                    value={pipelineType}
                    onChange={(e) => setpipelineType(e.target.value)}>
                    <option value="">Select</option>
                    {pipeline_type.map((data) => (
                      <option key={data.value} value={data.value}>
                        {data.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Pipeline Name */}
                <div className="mb-3">
                  <label className="form-label fw-medium">
                    Pipeline Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={pipelineName}
                    onChange={(e) => setPipelineName(e.target.value)}
                    placeholder="Enter pipeline name"
                    required
                  />
                </div>

                {/* Pipeline Stages */}
                <div className="mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="form-label fw-medium">
                      Pipeline Stages <span className="text-danger">*</span>
                    </label>
                    <Link
                      to="#"
                      onClick={(e: any) => {
                        e.preventDefault();
                        addStage();
                      }}
                      className="text-primary d-inline-flex align-items-center">
                      <i className="ti ti-plus me-1" /> Add New
                    </Link>
                  </div>

                  {stages.map((stage, index) => (
                    <div
                      key={stage.id}
                      className="bg-light rounded border p-3 mb-2">
                      <div className="d-flex align-items-center mb-2">
                        <input
                          type="text"
                          className="form-control me-2"
                          value={stage.name}
                          onChange={(e) =>
                            updateStageName(stage.id, e.target.value)
                          }
                          placeholder={`Stage ${index + 1}`}
                          required
                        />
                        <input
                          type="color"
                          className="form-control me-2"
                          style={{ maxWidth: "50px" }}
                          value={stagesColor[index]?.color || "#FFFFFF"}
                          onChange={(e) =>
                            updateStageNameColor(
                              stagesColor[index].id,
                              e.target.value
                            )
                          }
                        />
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => removeStage(stage.id)}>
                          <i className="ti ti-trash" />
                        </button>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        <div className="d-flex align-items-center">
                          <label className="form-label mb-0 me-2 text-nowrap small fw-medium">Type:</label>
                          <select
                            className="form-select form-select-sm"
                            style={{ minWidth: "110px" }}
                            value={stagesConfig[index]?.stage_type || "normal"}
                            onChange={(e) =>
                              updateStageConfig(stage.id, "stage_type", e.target.value)
                            }>
                            <option value="normal">Normal</option>
                            <option value="won">Won</option>
                            <option value="lost">Lost</option>
                          </select>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`reminder-${stage.id}`}
                            checked={stagesConfig[index]?.require_reminder !== false}
                            onChange={(e) =>
                              updateStageConfig(stage.id, "require_reminder", e.target.checked)
                            }
                          />
                          <label className="form-check-label small" htmlFor={`reminder-${stage.id}`}>
                            Require Reminder
                          </label>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="modal-footer bg-light border-top-0">
                <button
                  className="btn btn-outline-secondary me-2"
                  data-bs-dismiss="modal"
                  id="close-model-form">
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}>
                  Save Pipeline
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="edit_pipeline">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content" style={{ position: "relative" }}>
              {isEditLoading && (
                <div style={{
                  position: "absolute",
                  inset: 0,
                  background: "rgba(255,255,255,0.7)",
                  zIndex: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "inherit",
                }}>
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Updating...</span>
                  </div>
                </div>
              )}
              <div className="modal-header">
                <h4 className="modal-title">Edit Pipeline</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close">
                  <i className="ti ti-x" />
                </button>
              </div>

              <div className="modal-body pb-0">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Type <span className="text-danger"> *</span>
                    </label>
                    <select
                      className="form-control"
                      name="type"
                      value={selectedPipeline?.Type || ""}
                      onChange={(e) =>
                        setSelectedPipeline({
                          ...selectedPipeline,
                          Type: e.target.value,
                        })
                      }>
                      <option value="">Select</option>
                      {pipeline_type.map((data) => (
                        <option key={data.value} value={data.value}>
                          {data.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Pipeline Name <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={selectedPipeline?.Pipeline_Name || ""}
                    onChange={(e) =>
                      setSelectedPipeline({
                        ...selectedPipeline,
                        Pipeline_Name: e.target.value,
                      })
                    }
                    required
                  />
                </div>

                <div className="input-block mb-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <label className="form-label">
                      Pipeline Stages <span className="text-danger"> *</span>
                    </label>
                    <div className="d-flex justify-content-between align-items-center">
                      <Link
                        to="#"
                        className="add-new text-primary"
                        onClick={(e: any) => {
                          e.preventDefault();
                          const updatedStages = [
                            ...(selectedPipeline?.Stages || []),
                            "",
                          ];
                          setSelectedPipeline({
                            ...selectedPipeline,
                            Stages: updatedStages,
                            Stages_Config: [
                              ...(selectedPipeline?.Stages_Config || []),
                              { require_reminder: true, stage_type: "normal" },
                            ],
                          });

                          const updatedStagesColor = [
                            ...(selectedPipelineColor?.Color || []),
                            "#FFFFFF",
                          ];
                          setSelectedPipelineColor({
                            ...selectedPipelineColor,
                            Color: updatedStagesColor,
                          });
                        }}>
                        <i className="ti ti-plus text-primary me-1" />
                        Add New
                      </Link>
                    </div>
                  </div>

                  {selectedPipeline?.Stages?.map((stage: any, index: any) => {
                    const stageConf = selectedPipeline?.Stages_Config?.[index] || {
                      require_reminder: true,
                      stage_type: "normal",
                    };

                    return (
                      <div
                        key={index}
                        className="bg-light rounded border p-3 mb-2">
                        <div className="d-flex align-items-center mb-2">
                          {/* Stage Name Input */}
                          <input
                            type="text"
                            className="form-control me-2"
                            value={stage}
                            onChange={(e) => {
                              let updatedStages = [...selectedPipeline.Stages];
                              updatedStages[index] = e.target.value;
                              setSelectedPipeline({
                                ...selectedPipeline,
                                Stages: updatedStages,
                              });
                            }}
                            placeholder={`Stage ${index + 1}`}
                            required
                          />

                          {/* Color Input */}
                          <input
                            type="color"
                            className="form-control me-2"
                            style={{ maxWidth: "50px" }}
                            value={
                              selectedPipelineColor?.Color?.[index] || "#FFFFFF"
                            }
                            onChange={(e) => {
                              const updated = [
                                ...(selectedPipelineColor?.Color || []),
                              ];
                              updated[index] = e.target.value;
                              setSelectedPipelineColor({
                                ...selectedPipelineColor,
                                Color: updated,
                              });
                            }}
                          />

                          {/* Delete Button */}
                          <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => {
                              let updatedStages =
                                selectedPipeline.Stages.filter(
                                  (_: any, i: any) => i !== index
                                );
                              let updatedConfig = (
                                selectedPipeline.Stages_Config || []
                              ).filter((_: any, i: any) => i !== index);
                              setSelectedPipeline({
                                ...selectedPipeline,
                                Stages: updatedStages,
                                Stages_Config: updatedConfig,
                              });
                            }}
                            title="Delete stage">
                            <i className="ti ti-trash" />
                          </button>
                        </div>
                        <div className="d-flex align-items-center gap-3">
                          <div className="d-flex align-items-center">
                            <label className="form-label mb-0 me-2 text-nowrap small fw-medium">Type:</label>
                            <select
                              className="form-select form-select-sm"
                              style={{ minWidth: "110px" }}
                              value={stageConf.stage_type || "normal"}
                              onChange={(e) => {
                                const updatedConfig = [
                                  ...(selectedPipeline?.Stages_Config || []),
                                ];
                                updatedConfig[index] = {
                                  ...updatedConfig[index],
                                  stage_type: e.target.value,
                                };
                                setSelectedPipeline({
                                  ...selectedPipeline,
                                  Stages_Config: updatedConfig,
                                });
                              }}>
                              <option value="normal">Normal</option>
                              <option value="won">Won</option>
                              <option value="lost">Lost</option>
                            </select>
                          </div>
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`edit-reminder-${index}`}
                              checked={stageConf.require_reminder !== false}
                              onChange={(e) => {
                                const updatedConfig = [
                                  ...(selectedPipeline?.Stages_Config || []),
                                ];
                                updatedConfig[index] = {
                                  ...updatedConfig[index],
                                  require_reminder: e.target.checked,
                                };
                                setSelectedPipeline({
                                  ...selectedPipeline,
                                  Stages_Config: updatedConfig,
                                });
                              }}
                            />
                            <label className="form-check-label small" htmlFor={`edit-reminder-${index}`}>
                              Require Reminder
                            </label>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                    id="cancle-btn-model">
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSubmitUpdate}
                    disabled={isEditLoading}>
                    {isEditLoading ? "Updating..." : "Update Pipeline"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <DeleteModal
          modalId="delete_modal"
          onDelete={handleDelete}
          title="Delete Item"
          message="Are you sure you want to delete this item? This action cannot be undone."
        />
      </>
    );
  }
};

export default Pipeline;
